import { Directive, Input, ElementRef, Output, EventEmitter } from '@angular/core';

@Directive({
  selector: '[appLastitem]'
})
export class LastitemDirective {
  @Output() OnLastLoaded = new EventEmitter<boolean>(true);
  @Output() OnLastItemLoaded = new EventEmitter<any>(true);
  @Input('last-item')
  set lastItem(value) {
    // console.log('last item', value);
    if (value === true) {
      this.OnLastLoaded.emit(true);
    }
  }

  @Input('last-object')
  set lastObject(value) {
    // console.log('last item', value);
    this.OnLastItemLoaded.emit(true);
  }

  constructor(el: ElementRef) {
    // console.log('last-item directive', el.nativeElement);
  }

}



// WEBPACK FOOTER //
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/share/directives/lastitem.directive.ts